import type { TranslationMessages } from '../types';

export const products: TranslationMessages = {
  edit: 'Sửa sản phẩm',
  create: 'Tạo sản phẩm',
  editDescription: 'Cập nhật thông tin sản phẩm',
  createDescription: 'Thêm sản phẩm mới vào hệ thống',
  basicInfo: 'Thông tin cơ bản',
  fields: {
    name: 'Tên',
    namePlaceholder: 'Nhập tên sản phẩm',
    description: 'Mô tả',
    descriptionPlaceholder: 'Nhập mô tả sản phẩm',
    categoryId: 'Danh mục',
    categoryIdPlaceholder: 'Chọn danh mục (không bắt buộc)',
    price: 'Giá',
    pricePlaceholder: 'Nhập giá',
    currency: 'Tiền tệ',
    currencyPlaceholder: 'Chọn tiền tệ',
    recipeId: 'Công thức',
    recipeIdPlaceholder: 'Chọn công thức (không bắt buộc)',
    markupPercentage: 'Tỷ lệ lợi nhuận (%)',
  },
  recipe: {
    noneStockBased: 'Không (Dựa trên kho)',
  },
  cost: {
    title: 'Tính toán chi phí',
    calculating: 'Đang tính...',
    calculate: 'Tính chi phí',
    baseCost: 'Chi phí gốc',
    suggestedPrice: 'Giá đề xuất',
    suggestedFormula:
      'Giá đề xuất = Chi phí gốc × (1 + %{markupPercentage}%) = %{suggestedPrice} %{currency}',
    breakdown: 'Chi tiết chi phí',
    useSuggestedPrice: 'Dùng giá đề xuất',
  },
  errors: {
    selectRecipeFirst: 'Vui lòng chọn công thức trước',
    saveProductFirst: 'Vui lòng lưu sản phẩm trước để tính chi phí',
  },
  delete_title: 'Xóa Sản Phẩm',
  delete_confirm:
    'Bạn có chắc chắn muốn xóa sản phẩm này không? Hành động này không thể hoàn tác.',
  delete_error: 'Không thể xóa sản phẩm. Vui lòng thử lại.',
  delete_error_permission:
    'Bạn không có quyền xóa sản phẩm. Vui lòng liên hệ quản trị viên.',
  delete_success: 'Xóa sản phẩm thành công',
  name: 'Sản phẩm |||| Sản phẩm',
  recipe_based: 'Dựa trên công thức',
  stock_based: 'Dựa trên kho',
};
